import { memo, useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import Pane from 'components/Common/Pane'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { getThemeClassName } from 'lib/theme/themeUtils'

const Wrapper = styled(Pane)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};

 ${mediaQueryUp.desktop} {
   padding-top: ${rem(80)};
 }
`

interface Props {
  title: string
  filters: App.OfferListFilters
  overrideOfferIds?: Array<string>
}

function HeroOfferCarouselSection(props: Props) {
  const filters = useMemo(() => {
    return {
      ...props.filters,
      useUnifiedSearchEndpoint: true,
    }
  }, [props.filters])

  const overrideOfferList = useMemo<App.OfferList | undefined>(() => {
    if (!props.overrideOfferIds?.length) return undefined
    return { offerIds: props.overrideOfferIds, fetching: false, error: null, key: 'contentful-override' }
  }, [props.overrideOfferIds])

  return (
    <Wrapper paletteType="inverse">
      <Group direction="vertical" gap={24}>
        <LayoutContainer>
          <Heading variant="heading2" dangerouslySetInnerHTML={{ __html: props.title }} />
        </LayoutContainer>
        <OfferListCarousel
          tileStyle="hero"
          filters={overrideOfferList ? undefined : filters}
          overrideOfferList={overrideOfferList}
          className={getThemeClassName({ desktop: 'default' })}
        />
      </Group>
    </Wrapper>
  )
}

export default memo(HeroOfferCarouselSection)
